export default {
      id: "reports_fuel-usage",
      viewBox: "0 0 48 50",
      url: __webpack_public_path__ + "img/icons.svg#reports_fuel",
      toString: function () {
        return this.url;
      }
    }